(() => {
  const selector =
    'klarna-placement[data-key="credit-promotion-auto-size"]';

  function updateKlarnaMessage(klarna) {
    const root = klarna.shadowRoot;
    if (!root) return false;

    const message = root.querySelector('[part~="osm-message"]');
    if (!message) return false;

    // Avoid reprocessing our already-modified message.
    if (message.dataset.customized === 'true') return true;

    // Grab the outer Klarna logo element.
    const logo = message.querySelector(':scope > [part~="osm-logo"]');

    if (!logo) return false;

    // Remove everything currently inside the message,
    // but keep a reference to Klarna's original logo node.
    message.replaceChildren();

    // Build:
    // Buy now. Pay with [Klarna logo].
    message.append(
      document.createTextNode('Buy now. Pay with '),
      logo
    );

    message.dataset.customized = 'true';

    return true;
  }

  function initKlarna() {
    const klarna = document.querySelector(selector);

    if (!klarna) {
      requestAnimationFrame(initKlarna);
      return;
    }

    const waitForContent = () => {
      const root = klarna.shadowRoot;

      if (!root) {
        requestAnimationFrame(waitForContent);
        return;
      }

      const message = root.querySelector('[part~="osm-message"]');

      if (!message) {
        requestAnimationFrame(waitForContent);
        return;
      }

      updateKlarnaMessage(klarna);

      // Klarna may rerender the message after price/variant updates.
      const observer = new MutationObserver(() => {
        updateKlarnaMessage(klarna);
      });

      observer.observe(root, {
        childList: true,
        subtree: true
      });
    };

    waitForContent();
  }

  initKlarna();
})();